import { AxiosInstance } from 'axios';
import {
  TacticalSchema,
  ListTacticalSchemasResponse,
} from '../models/tactical-schema';

const baseUrl = process.env.REACT_APP_BASE_URL;

export interface TacticalSchemaCreateBody {
  name: string;
  mode: 'roster' | 'figure';
  fieldConfig: TacticalSchema['fieldConfig'];
  layers: TacticalSchema['layers'];
  isTemplate?: boolean;
  sourceBlockId?: string;
  thumbnail?: string;
}

export interface ListQuery {
  isTemplate?: boolean;
  isLeopartTemplate?: boolean;
  mine?: boolean;
  mode?: 'roster' | 'figure';
  sport?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export const buildTacticalSchemasEndpoints = (axios: AxiosInstance) => ({
  list: (params: ListQuery = {}) =>
    axios.get<ListTacticalSchemasResponse>(`${baseUrl}/tactical-schemas`, { params }),
  one: (id: string) =>
    axios.get<TacticalSchema | null>(`${baseUrl}/tactical-schemas/${id}`),
  create: (body: TacticalSchemaCreateBody) =>
    axios.post<TacticalSchema>(`${baseUrl}/tactical-schemas`, body),
  update: (id: string, body: Partial<TacticalSchemaCreateBody>) =>
    axios.patch<TacticalSchema>(`${baseUrl}/tactical-schemas/${id}`, body),
  remove: (id: string) => axios.delete(`${baseUrl}/tactical-schemas/${id}`),
  duplicate: (id: string) =>
    axios.post<TacticalSchema>(`${baseUrl}/tactical-schemas/${id}/duplicate`),
});
